export function AgntLogo({ size = 36 }: { size?: number }) {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 64 64"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			{/* Human head */}
			<circle cx="24" cy="18" r="11" fill="currentColor" opacity="0.9" />
			{/* Human shoulders */}
			<path
				d="M6 54c0-12 8-18 18-18s18 6 18 18"
				stroke="currentColor"
				strokeWidth="5"
				strokeLinecap="round"
				fill="none"
				opacity="0.9"
			/>
			{/* AI node — large */}
			<circle cx="50" cy="14" r="8" fill="var(--accent)" />
			<circle cx="50" cy="14" r="3.5" fill="var(--bg-primary)" />
			{/* Connection line from AI to human */}
			<line x1="42" y1="16" x2="35" y2="18" stroke="var(--accent)" strokeWidth="3" strokeLinecap="round" opacity="0.7" />
			{/* Second node */}
			<circle cx="52" cy="34" r="5" fill="var(--accent)" opacity="0.6" />
			<line x1="50" y1="22" x2="52" y2="29" stroke="var(--accent)" strokeWidth="3" strokeLinecap="round" opacity="0.5" />
		</svg>
	);
}
